import React from 'react';
import './ButtonGroup.css';
import cs from 'classnames';
export default function ButtonGroup(_ref) {
  var _ref$inline = _ref.inline,
    inline = _ref$inline === void 0 ? false : _ref$inline,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'right' : _ref$position,
    style = _ref.style,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: cs("_dm-button-group _dm-button-group--".concat(position), {
      '_dm-button-group--inline': inline
    }),
    style: style
  }, children);
}